import React, { useMemo } from 'react';

import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import LoginContainer, { ERROR_AUTH_INVALID_CREDENTIALS } from './LoginContainer';

const ErrorContainer = styled.div`
    margin-bottom: 2rem;
`;

export interface AuthErrorProps {}

const AuthError: React.FC<AuthErrorProps> = () => {
    const { authError } = useContainer(LoginContainer);
    const { t } = useTranslation('login');

    const errorMessage = useMemo(() => {
        switch (authError) {
            case ERROR_AUTH_INVALID_CREDENTIALS:
                return t('errors.bad-login-attempt');
            default:
                return t('errors.generic', { error: authError });
        }
    }, [authError, t]);

    if (authError === null) return null;

    return (
        <ErrorContainer>
            <Alert severity="error">{errorMessage}</Alert>
        </ErrorContainer>
    );
};

export default AuthError;
